import { useEffect } from 'react'

function SmoothscrollLoader(): null {
  useEffect(() => {
    const timerId = setTimeout(() => {
      // load smoothscroll polyfill only for desktop
      if (typeof window !== 'undefined') {
        import('smoothscroll-polyfill').then((smoothscroll) => {
          smoothscroll.polyfill()
        })
      }
    }, 1000)

    return () => clearTimeout(timerId)
  }, [])

  return null
}

export default SmoothscrollLoader
